import {combineReducers} from 'redux';
import {getCombinedReducers as getClaimsCombinedReducers} from './claims/reducers';
import {getCombinedReducers as getDetailsCombinedReducers} from './details/reducers';
import {getCombinedReducers as getSummaryCombinedReducers} from './summary/reducers';

export const getCombinedReducers = () => combineReducers({
    claims: getClaimsCombinedReducers(),
    details: getDetailsCombinedReducers(),
    summary: getSummaryCombinedReducers()
});



// WEBPACK FOOTER //
// ./src/reimbursement-summary/reimbursement-summary-reducers.js